import type { FC } from "react";
import React from "react";

import { bindArgs } from "@core/foundation/function";

import { Drawer, DrawerContent } from "@react/ui-primitives/drawer";

import type { LogEntry } from "@apis/calorie-grid/models";

import { LogEntryDetailsDrawerContent } from "./LogEntryDetailsDrawerContent.tsx";

interface LogEntryDetailsSheetProps {
  readonly logEntry: LogEntry | null;
  readonly onOpenChange: (open: boolean) => void;
  readonly open: boolean;
}

export const LogEntryDetailsSheet: FC<LogEntryDetailsSheetProps> = ({
  logEntry,
  onOpenChange,
  open,
}) => (
  <Drawer onOpenChange={onOpenChange} open={open}>
    <DrawerContent>
      {logEntry && (
        <LogEntryDetailsDrawerContent
          logEntry={logEntry}
          onClose={bindArgs(onOpenChange, false)}
        />
      )}
    </DrawerContent>
  </Drawer>
);
